<template>
  <div class="register absolute" v-loading="loading">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/logo.png" v-else />
      </div>
    </div>
    <div class="whiteBg" v-if="formItem === 1">
      <div class="title acea-row row-center-wrapper">
        <div
          class="item"
          :class="current === index ? 'on' : ''"
          v-for="(item, index) in navList"
          @click="navTap(index)"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="list" :hidden="current !== 0">
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input
                type="text"
                placeholder="输入手机号码"
                v-model="account"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="password"
                placeholder="填写登录密码"
                v-model="password"
                required
              />
            </div>
          </div>
        </form>
        <div
          class="forgetPwd"
          @click="$router.push({ name: 'RetrievePassword' })"
        >
          <span class="iconfont icon-wenti"></span>忘记密码
        </div>
      </div>
      <div class="list" :hidden="current !== 1">
        <div class="item">
          <div class="acea-row row-between-wrapper">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item" v-if="isShowCode">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="codeVal"
            />
            <div class="code" @click="again"><img :src="codeUrl" /></div>
          </div>
        </div>
      </div>
      <div class="logon" @click="loginMobile" :hidden="current !== 1">登录</div>
      <div class="logon" @click="submit" :hidden="current === 1">登录</div>
      <div class="tip">
        没有账号?
        <span @click="formItem = 2" class="font-color-red">立即注册</span>
      </div>
    </div>
    <div class="whiteBg" v-else>
      <div class="title">注册账号</div>
      <div class="list">
        <div class="item">
          <div style="display:flex;align-items: center;">
            <img class="userNameLogo" src="../../assets/images/user.png" alt="">
            <input type="text" placeholder="输入用户名" v-model="nickname" />
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="password"
              placeholder="填写您的登录密码"
              v-model="password"
            />
          </div>
        </div>
        <div class="item" v-if="isShowCode">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="codeVal"
            />
            <div class="code" @click="again"><img :src="codeUrl" /></div>
          </div>
        </div>
      </div>
      <!-- 两个按钮： 成为零售商还是批发商 -->
      <div class="selectBox">

        <div class="neoBox" @click="registerSign = 1">
          <img v-if="registerSign == 1"  src="../../assets/images/active.png" alt="">
          <div v-else class="activeNone"></div>
          <div>普通会员</div>
        </div>

        <div class="neoBox" @click="registerSign = 2">
          <img v-if="registerSign == 2"  src="../../assets/images/active.png" alt="">
          <div v-else class="activeNone"></div>
          <div>批发商</div>
        </div>
      </div>
      <div class="uploadBox" v-show="registerSign == 2">
            <div>
                <div style="margin: 0 0px 0.2rem;">上传营业执照</div>
                <div v-if="!file1" class="addImg" @click="choseImg1">+</div>
                <img v-else class="uploadImg" @click="choseImg1" :src="file1" alt="">
            </div>
            <div>
                <div style="margin: 0 0px 0.2rem;">上传身份证</div>
                <div v-if="!file2" class="addImg" @click="choseImg2">+</div>
                <img v-else class="uploadImg" @click="choseImg2" :src="file2" alt="">
            </div>
      </div>
      <input type="file" style="display: none;" ref="file1" accept="image/*" @change="file1Change">
      <input type="file" style="display: none;" ref="file2" accept="image/*" @change="file2Change">

      
      <div class="logon" @click="register" style="margin-top: 10px;">注册</div>
      <div class="tip">
        已有账号?
        <span @click="formItem = 1" class="font-color-red">立即登录</span>
      </div>
    </div>
    <div class="bottom"></div>
    <div class="marker" v-show="loadingMarker" @click.stop="function(){}">

      <div class="markerTips">上传中</div>

    </div>
  </div>
</template>
<script>
var _mine
import sendVerifyCode from "@mixins/SendVerifyCode";
import {
  login,
  loginMobile,
  registerVerify,
  register,
  getCodeApi,
  errlog
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo, uploadImg } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";
import { log } from 'util';

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  mixins: [sendVerifyCode],
  data: function() {
    return {
      loading: false,
      // 用户名
      nickname: '',
      navList: ["账号登录", "快速登录"],
      current: 1,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      registerSign: 1,
      isShowCode: false,
      // 营业执照
      file1: null,
      hasFile1: false,
      // 身份证
      file2: null,
      hasFile2: false,
      loadingMarker: false
    };
  },
  mounted: function() {
    _mine = this
    this.getCode();
    this.getLogoImage();
    if(this.$route.params){
      this.account = this.$route.params.account
      this.password = this.$route.params.password
    }

    errlog(111)
  },
  methods: {
    choseImg1: function() {
        this.$refs.file1.click()
    },
    choseImg2: function(){
        this.$refs.file2.click()
    },
    file1Change: function(e) {
      const file = this.$refs.file1.files[0]
      const type = file.type.substring(0, 5)
      const size = file.size / 1024
      if (type != 'image') return this.$dialog.error('请选择图片上传');
      if(size >= 10240) return this.$dialog.error('请上传小于5MB的图片');
      this.loadingMarker = true
      let param = new FormData()  // 创建form对象
      param.append('file', file) 
      uploadImg(param).then(res => {
        console.log(res);
        const { url } = res.data.data
        _mine.file1 = url
        _mine.loadingMarker = false
      }).catch(err => {
        _mine.loadingMarker = false
        console.log(err);
        _mine.$dialog.error('上传失败');
      })
    },
    file2Change: function(e) {
      const file = this.$refs.file2.files[0]
      const type = file.type.substring(0, 5)
      const size = file.size / 1024
      if (type != 'image') return this.$dialog.error('请选择图片上传')
      if(size >= 10240) return this.$dialog.error('请上传小于5MB的图片')
      this.loadingMarker = true
      let param = new FormData()  // 创建form对象
      param.append('file', file) 
      uploadImg(param).then(res => {
        const { url } = res.data.data
        _mine.file2 = url
        _mine.loadingMarker = false
      }).catch(err => {
        console.log(err);
        _mine.loadingMarker = false
        _mine.$dialog.error(err.msg);
      })
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          window.localStorage.setItem('token', data.token)
          that.$store.commit("LOGIN", data.token);
          // let newTime = Math.round(new Date() / 1000)
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({ path: backUrl });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      this.loading = true
      var that = this;
      const { account, captcha, password, file1, file2 } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        this.loading = false
        return validatorDefaultCatch(e);
      }
      let nickname = that.nickname.trim()
      let obj = {
        nickname,
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread")
      }

      if(this.registerSign == 2 ) {
        if(!file1) {
          this.loading = false
          return that.$dialog.error('营业执照照片不能为空');
        }
        if(!file2) {
          this.loading = false
          return that.$dialog.error('身份证照片不能为空');
        }
        // 成为批发商
        obj.license = that.file1
        obj.card = that.file2
        obj.wholesale = 2
      }

      register(obj)
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
          this.loading = false
        })
        .catch(res => {
          that.$dialog.error(res.msg || res);
          this.loading = false
          errlog(res)
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (that.formItem == 2) that.type = "register";
      await registerVerify({
        phone: that.account,
        type: that.type,
        key: that.keyCode,
        code: that.codeVal
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },
    navTap: function(index) {
      this.current = index;
    },
    async submit() {
      const { account, password, codeVal } = this;
      try {
        await this.$validator({
          account: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码"))
          ],
          codeVal: this.isShowCode
            ? [
                required(required.message("验证码")),
                attrs.length(4, attrs.length.message("验证码")),
                alpha_num(alpha_num.message("验证码"))
              ]
            : []
        }).validate({ account, password, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ account, password, code: codeVal })
        .then(({ data }) => {
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          console.log(data.token);
          window.localStorage.setItem('token', data.token) 
          this.$store.commit("LOGIN", data.token);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl, query: { login: 1} });
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    },
    // 成为批发商
    toBeWholesaler: function() {
      // this.$route.go('/toBeWholesaler')
      this.$router.push('/toBeWholesaler')
    }
  }
};
</script>
<style scoped>
.marker{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}
.markerTips{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.15rem 0.2rem ;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 5px;
}

.code img {
  width: 100%;
  height: 100%;
}
.selectBox{
    width: 100%;
    display: flex;
    justify-content: space-around;
    height: 0.75rem;
}
.neoBox{
  display: flex;
  color: #fc4141;
  align-items: center;
}
.activeNone{
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 0.1rem;
}
.selectBox img{
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}
.uploadBox{
  display: flex;
  justify-content: space-between;
  margin: 0.1rem 0;
  text-align: center;
}
.addImg{
    width: 2.5rem;
    height: 2.5rem;
    border: 1px dashed #ccc;
    border-radius: 5px;
    font-size: 0.75rem;
    line-height: 2.5rem;
    text-align: center;
    box-sizing: border-box;
}
.uploadImg{
  width: 2.5rem;
  height: 2.5rem;
  box-sizing: border-box;
}
.userNameLogo{
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.32rem;
}
</style>
